module.exports = __webpack_public_path__ + "static/media/national-2-compressed-web-medium.20c98bf1.woff";